var scope_0 = require('/vercel/workpath0/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/cf3564d2c4174c7618117f14d423fb81.js').default;export default
        Object.assign({}, scope_0 )
    